import { Component, Input, OnInit } from '@angular/core';
import { Offer, OfferType } from '../../models/offers.model';
import { WindowRefService } from '../../../../services/window-ref.service';
import { EventTrackingService } from '../../../../services/event-tracking.service';
import { LinkClickCustomerPortal } from '../../../../models/event-data.model';
import { AuthEventRepo, AuthEventType } from '../../../../enums/event/event.enum';
import { CookieService } from 'ngx-cookie-service';

import { MatDialog } from '@angular/material/dialog';
import { OffersService } from '../../services/offers.service';
import { OffersDisclosureComponent } from '../offers-disclosure/offers-disclosure.component';

@Component({
    selector: 'app-credit-offer',
    templateUrl: './credit-offer.component.html',
    styleUrls: ['./credit-offer.component.scss'],
    standalone: false
})
export class CreditOfferComponent implements OnInit {
  @Input() offer: Offer;

  constructor(
    private readonly windowRefService: WindowRefService,
    private readonly eventTrackingService: EventTrackingService,
    private readonly offersService: OffersService,
    private readonly cookieService: CookieService,
    private readonly matDialog: MatDialog
  ) {}

  /**
   * This component needs to be updated once all the offer type ENUM values are known
   */
  ngOnInit(): void {

    if (this.offer?.offerType !== OfferType.BEFH_CTA) {
      const EVENT = '[Auth] Offers No Promo No Rewards Credit Card offer seen';
      this.windowRefService.nativeWindow.FS.event(EVENT);
      this.offersService.trackSeenEvent({
        offer: this.offer,
        placement: '_SECONDARY',
        siteSection: 'offers',
      });
    }

    if (this.offer?.offerType === OfferType.BEFH_CTA) {
      const eventData = this.getBefhSeenEventData(this.offer);
      this.eventTrackingService.trackEvent(AuthEventType.SEEN_BEFH_PLACEMENT, eventData)
    }
  }

  openDisclosureModal() {
    this.matDialog.open(OffersDisclosureComponent, {
      data: this.offer.productType,
      panelClass: 'disclosure-dialog',
      backdropClass: 'disclosure-backdrop',
    });
  }

  getBefhSeenEventData(offer: Offer) {
    return {
      cid: this.cookieService.get('cid'),
      eventRepo: AuthEventRepo.CustomerPortal,
      customerPortalDisplayText: this.stripHtmlTags(offer.heading),
      product: 'FINANCIAL_HEALTH',
      customerPortalDisplayType: 'Financial Health',
      siteSection: 'offers',
    }
  }

  private stripHtmlTags(text: string | null | undefined): string {
    if (!text) return '';
    // Remove HTML tags by creating a temporary DOM element
    // This is more robust than regex and handles malformed HTML
    const doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.body.textContent || '';
  }

  onGetOffer() {
    const FS_EVENT = '[Auth] Offers Credit Card offer clicked';
    if (this.offer?.offerType === OfferType.BEFH_CTA) {
      this.windowRefService.nativeWindow.FS.event(FS_EVENT);
      this.windowRefService.nativeWindow.open(this.offer.offerUrl, '_blank');
      const baseData = this.getBefhSeenEventData(this.offer);
      const linkClickData = {
        ...baseData,
        customerPortalClickLinkType: 'Financial Health',
        customerPortalDisplayText: this.stripHtmlTags(this.offer?.heading || this.offer?.callToAction),
        customerPortalClickLinkText: this.offer?.callToAction || this.offer?.label,
      };
      this.eventTrackingService.trackEvent<LinkClickCustomerPortal>(AuthEventType.LINK_CLICK, linkClickData as LinkClickCustomerPortal);
    } else {
      this.offersService.trackLinkClickEvent({
        offer: this.offer,
        placement: '_SECONDARY',
        siteSection: 'offers',
        fsEvent: FS_EVENT,
      });
      this.windowRefService.nativeWindow.open(this.offer.offerUrl, '_blank');
    }
  }
}
